import { DASHBOARD_SECTIONS_ROUTES } from '@/models/common/permissions.model';

export enum ENV_VAR_NAMES {
  APP_MODE = 'APP_MODE',
  MOCKS_ENABLED = 'MOCKS_ENABLED',
  BACKOFFICE_API_URL = 'BACKOFFICE_API_URL',
  WL_SLUG = 'WL_SLUG',
  SERVICE_PERMISSIONS = 'SERVICE_PERMISSIONS',
  CURRENT_PARTENT_ROUTE_NAME = 'CURRENT_PARTENT_ROUTE_NAME',
  MULTIBRAND_API_HOST = 'MULTIBRAND_API_HOST',
  MULTIBRAND_API_URL = 'MULTIBRAND_API_URL',
  WHITELABEL_ID = 'WHITELABEL_ID',
}

export enum DASHBOARD_MODES {
  STANDALONE = 'standalone',
  BACKOFFICE = 'backoffice',
}

export type EnvConfig = {
  [ENV_VAR_NAMES.APP_MODE]: DASHBOARD_MODES | string;
  [ENV_VAR_NAMES.MOCKS_ENABLED]: string;
  [ENV_VAR_NAMES.BACKOFFICE_API_URL]: string;
  [ENV_VAR_NAMES.WL_SLUG]: string;
  [ENV_VAR_NAMES.CURRENT_PARTENT_ROUTE_NAME]: PARENT_ROUTE_NAMES;
  [ENV_VAR_NAMES.MULTIBRAND_API_HOST]: string;
  [ENV_VAR_NAMES.MULTIBRAND_API_URL]: string;
  [ENV_VAR_NAMES.WHITELABEL_ID]: string;
};

export type EnvVariables = Record<string, string | undefined>;

export const DEFAULT_PROPS = (): DefaultProps => {
  return {
    apiUrl: 'https://dev.aramuz.net/backofficeapi',
    wlSlug: localStorage.getItem('defaultWlSlug') || '',
    currentParentRouteName: '',
    dashboardPermissions: '',
    multibrandApiUrl: '',
  };
};

export type Props = {
  apiUrl: string;
  wlSlug: string;
  currentParentRouteName: PARENT_ROUTE_NAMES;
  dashboardPermissions: string;
  multibrandApiUrl: string;
  whitelabelId: string;
}

export type DefaultProps = {
  apiUrl: Props['apiUrl'];
  wlSlug: Props['wlSlug'];
  currentParentRouteName: Props['currentParentRouteName'];
  dashboardPermissions: Props['dashboardPermissions'];
  multibrandApiUrl: Props['multibrandApiUrl'];
}

export type PARENT_ROUTE_NAMES = '' | DASHBOARD_SECTIONS_ROUTES;
/* Указываем все дочерние роуты этого микрофронта
для каждого из них создаем enum — один подраздел, один enum
export type PARENT_ROUTE_NAMES = '' | OTHER_ROUTE_NAMES | SOME_OTHER_ROUTE_NAMES;
*/
